import { useEffect, useState } from "react";
import api from "@/lib/api";
import { CATEGORIES, formatDate } from "@/lib/constants";

export default function Storie() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("");
  const [q, setQ] = useState("");

  useEffect(() => {
    const query = cat ? `?category=${cat}` : "";
    api.get(`/articles${query}`).then((r) => setItems(r.data));
  }, [cat]);

  const filtered = q ? items.filter((a) => (a.title + " " + (a.subtitle || "") + " " + (a.body || "")).toLowerCase().includes(q.toLowerCase())) : items;

  return (
    <div data-testid="storie-page">
      <section className="bg-[#FFF1E8] py-16">
        <div className="container-vv">
          <div className="eyebrow">Storie e risorse</div>
          <h1 className="mt-4 font-display font-medium text-5xl sm:text-6xl tracking-tight text-[#292522]">Cose che vale la pena raccontare</h1>
          <p className="mt-4 text-lg text-[#292522]/75 max-w-3xl">News, restituzioni, consigli di lettura, materiali. Uno spazio editoriale che cresce con noi.</p>
        </div>
      </section>

      <section className="container-vv py-8 sticky top-20 z-30 bg-[#FFFCF8]/90 backdrop-blur-md">
        <div className="flex flex-col gap-3">
          <input
            type="search"
            placeholder="Cerca nelle storie e risorse…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            className="w-full rounded-full bg-white border border-[#292522]/10 px-5 py-3 focus:border-[#FF6100] focus:ring-2 focus:ring-[#FF6100]/20 outline-none text-sm"
            data-testid="storie-search-input"
          />
          <div className="flex flex-wrap gap-2">
            <button onClick={() => setCat("")} className={`px-4 py-2 rounded-full text-xs font-semibold border ${!cat ? "bg-[#FF6100] text-white border-[#FF6100]" : "bg-white text-[#292522] border-[#292522]/10"}`}>Tutte</button>
            {CATEGORIES.map((c) => (
              <button key={c.key} onClick={() => setCat(c.key)} data-testid={`filter-cat-${c.key}`} className={`px-4 py-2 rounded-full text-xs font-semibold border ${cat === c.key ? "bg-[#FF6100] text-white border-[#FF6100]" : "bg-white text-[#292522] border-[#292522]/10"}`}>{c.label}</button>
            ))}
          </div>
        </div>
      </section>

      <section className="container-vv pb-24">
        {filtered.length === 0 ? (
          <div className="rounded-3xl bg-[#FFF1E8] p-12 text-center text-[#292522]/70">
            {q ? `Nessun risultato per "${q}".` : "Nessun articolo pubblicato in questa categoria."}
          </div>
        ) : (
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {filtered.map((a) => (
              <article key={a.id} className="card-vv p-8 bg-white flex flex-col" data-testid={`article-${a.id}`}>
                <span className="inline-block self-start rounded-full bg-[#FFF1E8] text-[#FF6100] text-xs font-semibold px-3 py-1">{a.category}</span>
                <h3 className="mt-4 font-display text-2xl font-medium text-[#292522]">{a.title}</h3>
                {a.subtitle && <p className="mt-2 text-sm text-[#292522]/60">{a.subtitle}</p>}
                <p className="mt-3 text-sm text-[#292522]/75 line-clamp-4 whitespace-pre-line">{a.body}</p>
                <p className="mt-auto pt-6 text-xs text-[#292522]/50">{a.author || "Redazione"} · {formatDate(a.published_at)}</p>
              </article>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
